module.exports = __webpack_public_path__ + "static/media/xstream-participant.ab675024.png";